import { Box, TextField, IconButton } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import RemoveIcon from "@mui/icons-material/Remove";


const INPUT_STYLE = { textAlign: "center", padding: "8px 0" };

const NumberControl = ({
  min = -11,
  max = 11,
  step = 1,
  value,
  onChange,
  textFieldWidth = 50,
  disabled = false,
}) => {
  const handleChange = (newValue) => {
    if (!isNaN(newValue) && newValue >= min && newValue <= max) {
      onChange(newValue);
    }
  };

  return (
    <Box display="flex" alignItems="center">
      <IconButton
        size="small"
        color="primary"
        onClick={() => handleChange(value - step)}
        disabled={value <= min}
      >
        <RemoveIcon />
      </IconButton>

      <TextField
        type="number"
        size="small"
        value={value}
        onChange={(e) => handleChange(parseInt(e.target.value, 10) || 0)}
        slotProps={{ htmlInput: { min, max, step, style: INPUT_STYLE } }}
        sx={{
          width: textFieldWidth,
          "& .MuiInputBase-root": { height: 36 },
        }}
      />

      <IconButton
        size="small"
        color="primary"
        onClick={() => handleChange(value + step)}
        disabled={value >= max || disabled}
      >
        <AddIcon />
      </IconButton>
    </Box>
  );
};

export default NumberControl;
